import React from 'react';

export default {
  sm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H16V16H0z" />
        <path
          className="icon-color"
          d="M15 8c0 3.866-3.135 7-7 7-3.866 0-7-3.134-7-7s3.134-7 7-7c3.865 0 7 3.134 7 7zM9.414 8l1.938-1.938c.39-.39.39-1.025 0-1.414-.39-.39-1.025-.39-1.414 0L8 6.586 6.062 4.648c-.39-.39-1.025-.39-1.414 0-.39.389-.39 1.025 0 1.414L6.586 8 4.648 9.938c-.39.39-.39 1.025 0 1.414.389.39 1.025.39 1.414 0L8 9.414l1.938 1.938c.389.39 1.025.39 1.414 0 .39-.39.39-1.024 0-1.414L9.414 8z"
        />
      </g>
    </svg>
  ),
  md: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" />
        <path
          className="icon-color"
          d="M22 12c0 5.523-4.478 10-10 10-5.523 0-10-4.477-10-10C2 6.478 6.477 2 12 2c5.522 0 10 4.478 10 10zm-8.585 0l3.44-3.44c.389-.39.389-1.025 0-1.415-.39-.389-1.025-.389-1.415 0L12 10.585l-3.44-3.44c-.39-.389-1.025-.389-1.414 0-.39.39-.39 1.025 0 1.415l3.44 3.44-3.44 3.44c-.39.39-.39 1.025 0 1.414.389.39 1.025.39 1.414 0l3.44-3.44 3.44 3.44c.39.39 1.025.39 1.415 0 .389-.389.389-1.025 0-1.414L13.415 12z"
        />
      </g>
    </svg>
  ),
};
